import React, { useMemo } from 'react'
import { Avatar } from '@node-space/ui-components'
import { WalletType } from 'types/types'
import { floorWithPrecision } from 'utils/utils'
import { SourcePayWallet } from '../../Pay/types'

interface UseWalletOptionsProps {
  wallet?: WalletType
  sourceWalletOptions?: any[]
  sourceWalletAtom?: SourcePayWallet | null
  activeWallets?: WalletType[]
}

export const useWalletOptions = ({
  wallet,
  sourceWalletOptions,
}: UseWalletOptionsProps) => {
  const walletsOptions = useMemo(() => {
    if (!wallet) {
      return sourceWalletOptions || []
    }

    return [
      {
        LeftElement: <Avatar name={wallet?.currency?.code?.toLowerCase()} size="small" />,
        value: wallet?.lsid,
        leftText: wallet?.description,
        rightText: `${floorWithPrecision(wallet?.balance ?? 0, wallet?.currency?.quantityPrecision)} ${wallet?.currency?.code}`,
      },
    ]
  }, [wallet, sourceWalletOptions])

  return { walletsOptions }
}
